/**
 * Инициализация системы темы
 * # ⛓️ CURSOR_ANCHOR:ui:theme-init
 */

(function() {
  'use strict';

  /**
   * Инициализация темы при загрузке страницы
   */
  function initTheme() {
    var storedTheme = window.THEME_STORAGE.get();
    
    window.THEME_APPLICATION.apply(storedTheme);
    window.THEME_UI.updateToggleButton(storedTheme);
    
    // Слушаем изменения системной темы (только если выбрана автоматическая)
    if (window.matchMedia) {
      var mediaQuery = window.matchMedia('(prefers-color-scheme: dark)');
      mediaQuery.addEventListener('change', function() {
        if (window.THEME_STORAGE.get() === window.THEME_CONSTANTS.AUTO) {
          window.THEME_APPLICATION.apply(window.THEME_CONSTANTS.AUTO);
          window.THEME_UI.updateToggleButton(window.THEME_CONSTANTS.AUTO);
        }
      });
    }
    
    // Обработчик должен быть привязан через initializeThemeSystem
    window.THEME_EVENTS.attachLogoHandler();
  }

  /**
   * Инициализировать систему темы
   */
  function initializeThemeSystem() {
    // Сначала инициализируем тему
    initTheme();
    
    // Затем пытаемся привязать прямой обработчик к логотипу
    var handlerAttached = window.THEME_EVENTS.attachLogoHandler();
    
    // Если обработчик не привязан, пробуем еще раз через небольшую задержку
    if (!handlerAttached) {
      setTimeout(function() {
        window.THEME_EVENTS.attachLogoHandler();
      }, 50);
    }
  }

  window.THEME_INIT = {
    init: initTheme,
    initialize: initializeThemeSystem
  };
})();

